export enum Weight {
    _400 = 400,
    _500 = 500,
    _700 = 700
}